var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 45.62C23.12 45.62 21.82 44.92 20.9 43.7L17.9 39.7C17.84 39.62 17.6 39.52 17.5 39.5H16.5C8.16 39.5 3 37.24 3 26V16C3 7.16 7.66 2.5 16.5 2.5H32.5C41.34 2.5 46 7.16 46 16V26C46 34.84 41.34 39.5 32.5 39.5H31.5C31.34 39.5 31.2 39.58 31.1 39.7L28.1 43.7C27.18 44.92 25.88 45.62 24.5 45.62ZM16.5 5.5C9.34 5.5 6 8.84 6 16V26C6 35.04 9.1 36.5 16.5 36.5H17.5C18.52 36.5 19.68 37.08 20.3 37.9L23.3 41.9C24 42.82 25 42.82 25.7 41.9L28.7 37.9C29.36 37.02 30.4 36.5 31.5 36.5H32.5C39.66 36.5 43 33.16 43 26V16C43 8.84 39.66 5.5 32.5 5.5H16.5Z",
    fill: "#4786FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 17.5H14.5C13.68 17.5 13 16.82 13 16C13 15.18 13.68 14.5 14.5 14.5H34.5C35.32 14.5 36 15.18 36 16C36 16.82 35.32 17.5 34.5 17.5Z",
    fill: "#4786FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 27.5H14.5C13.68 27.5 13 26.82 13 26C13 25.18 13.68 24.5 14.5 24.5H26.5C27.32 24.5 28 25.18 28 26C28 26.82 27.32 27.5 26.5 27.5Z",
    fill: "#4786FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageText);
export default __webpack_public_path__ + "static/media/message-text.90c54f71cc8d5270ab7aaed64f620b1b.svg";
export { ForwardRef as ReactComponent };